Vue.component('state-leaderboards', {
    data: function() {
        axios.get(API_URL + '/leaderboard').then((res) => {
            let data = res.data;

            let leaderboard = [];
            for (let i=0; i<data.leaderboard.length; i++) {
                let player = data.leaderboard[i];
                player.rank = game.services.user.calculateRank(player.xp);
                leaderboard.push(player);
            }

            this.leaderboard = leaderboard;
            this.loading = false;
        });

        return {
            loading: true,
            leaderboard: []
        };
    },
    template: `
    <div>
        <h1>Top 25 Players</h1>
        <div v-if="loading">
            <h1><i class="fa fa-refresh fa-spin"></i></h1>
        </div>
        <div v-if="!loading">
            <h3 v-if="leaderboard.length <= 0">No players found.</h3>
            <div v-for="(player, index) in leaderboard" class="app-card">
                {{ index+1 }}. {{ player.name }}
                <div class="pull-right">
                    <img class="icon-xs" src="assets/rank_icon.png"> <b> {{ player.rank }}</b>
                </div>
            </div>
            <br><br>
        </div>
    </div>
    `
})